'use client';
import { ComponentProps, ElementType, Fragment, useContext } from 'react';
import { cn } from '@/shared/lib/cn';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

type Props<T extends ElementType = 'h1'> = {
    size?: 'xl' | '2xl';
    as?: T;
} & ComponentProps<T>;

export const ProductDetailInfoName = <T extends ElementType = 'h1'>({
    as: Element = 'h1',
    size = 'xl',
    className,
    ...props
}: Props<T>) => {
    const { data } = useContext(ProductDetailContext);
    const getLocalizedValue = useGetLocalizedValue();
    if (!data?.name) {
        return null;
    }
    const nameValue = getLocalizedValue(data.name);
    return (
        <Element
            {...(Element !== Fragment
                ? {
                      className: cn(
                          'product-detail__info-name',
                          size === 'xl' && 'product-detail__info-name--xl',
                          size === '2xl' && 'product-detail__info-name--2xl',
                          className,
                      ),
                      'data-testid': 'product-detail-name',
                  }
                : {})}
            {...props}
        >
            {nameValue}
        </Element>
    );
};
